module.exports = __webpack_public_path__ + "img/Calendar.cee689a3.png";